import { Map as map } from 'immutable';
const C = require("../constants");

function ModalProductStockReducer(state = map(), action) {
    switch (action.type) {
        case C.PRODUCTS_STOCK_MODAL:
            return action.modal;
        default:
            return state;
    }
}

export default ModalProductStockReducer;


// WEBPACK FOOTER //
// ./src/reducers/ModalProductStockReducer.js